var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 135,
    viewBox: "0 0 177 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.639 115.853V121.95H170.551V115.853H176.639Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.639 109.761V115.853H170.551V109.761H176.639Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.639 91.4919V97.5803H170.551V91.4919H176.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.639 85.3996V91.4919H170.551V85.3996H176.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.639 79.3113V85.3997H170.551V79.3113H176.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.639 73.2188V79.3112H170.551V73.2188H176.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.639 67.1303V73.2188H170.551V67.1303H176.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55 115.853V121.95H164.458V115.853H170.55Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55 109.761V115.853H164.458V109.761H170.55Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55 91.4919V97.5803H164.458V91.4919H170.55Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55 67.1303V73.2188H164.458V67.1303H170.55Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 115.853V121.95H158.369V115.853H164.458Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 109.761V115.853H158.369V109.761H164.458Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 97.5802V103.673H158.369V97.5802H164.458Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 91.4919V97.5803H158.369V91.4919H164.458Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 85.3996V91.4919H158.369V85.3996H164.458Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 79.3113V85.3997H158.369V79.3113H164.458Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 73.2188V79.3112H158.369V73.2188H164.458Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.458 67.1303V73.2188H158.369V67.1303H164.458Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 115.853V121.95H152.277V115.853H158.37Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 109.761V115.853H152.277V109.761H158.37Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 97.5802V103.673H152.277V97.5802H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 91.4919V97.5803H152.277V91.4919H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 85.3996V91.4919H152.277V85.3996H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 79.3113V85.3997H152.277V79.3113H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 73.2188V79.3112H152.277V73.2188H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 67.1303V73.2188H152.277V67.1303H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37 61.038V67.1304H152.277V61.038H158.37Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 128.038V134.13H146.189V128.038H152.278Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 121.95V128.038H146.189V121.95H152.278Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 115.853V121.95H146.189V115.853H152.278Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 109.761V115.853H146.189V109.761H152.278Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 103.673V109.761H146.189V103.673H152.278Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 97.5802V103.673H146.189V97.5802H152.278Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 91.4919V97.5803H146.189V91.4919H152.278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 85.3996V91.4919H146.189V85.3996H152.278Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 79.3113V85.3997H146.189V79.3113H152.278Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 73.2188V79.3112H146.189V73.2188H152.278Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 67.1303V73.2188H146.189V67.1303H152.278Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.278 61.038V67.1304H146.189V61.038H152.278Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 128.038V134.13H140.096V128.038H146.188Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 121.95V128.038H140.096V121.95H146.188Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 115.853V121.95H140.096V115.853H146.188Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 109.761V115.853H140.096V109.761H146.188Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 103.673V109.761H140.096V103.673H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 97.5802V103.673H140.096V97.5802H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 91.4919V97.5803H140.096V91.4919H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 85.3996V91.4919H140.096V85.3996H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 79.3113V85.3997H140.096V79.3113H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 73.2188V79.3112H140.096V73.2188H146.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 67.1303V73.2188H140.096V67.1303H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 61.038V67.1304H140.096V61.038H146.188Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 54.9418V61.0381H140.096V54.9418H146.188Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.188 48.8534V54.9418H140.096V48.8534H146.188Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 128.038V134.13H134.008V128.038H140.096Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 121.95V128.038H134.008V121.95H140.096Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 115.853V121.95H134.008V115.853H140.096Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 109.761V115.853H134.008V109.761H140.096Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 103.673V109.761H134.008V103.673H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 97.5802V103.673H134.008V97.5802H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 91.4919V97.5803H134.008V91.4919H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 85.3996V91.4919H134.008V85.3996H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 79.3113V85.3997H134.008V79.3113H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 73.2188V79.3112H134.008V73.2188H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 67.1303V73.2188H134.008V67.1303H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 61.038V67.1304H134.008V61.038H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 54.9418V61.0381H134.008V54.9418H140.096Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.096 48.8534V54.9418H134.008V48.8534H140.096Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 128.038V134.13H127.912V128.038H134.008Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 121.95V128.038H127.912V121.95H134.008Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 115.853V121.95H127.912V115.853H134.008Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 109.761V115.853H127.912V109.761H134.008Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 103.673V109.761H127.912V103.673H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 97.5802V103.673H127.912V97.5802H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 91.4919V97.5803H127.912V91.4919H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 85.3996V91.4919H127.912V85.3996H134.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 79.3113V85.3997H127.912V79.3113H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 73.2188V79.3112H127.912V73.2188H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 67.1303V73.2188H127.912V67.1303H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 61.038V67.1304H127.912V61.038H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 54.9418V61.0381H127.912V54.9418H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 48.8534V54.9418H127.912V48.8534H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.008 42.7611V48.8534H127.912V42.7611H134.008Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 128.038V134.13H121.819V128.038H127.912Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 121.95V128.038H121.819V121.95H127.912Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 115.853V121.95H121.819V115.853H127.912Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 109.761V115.853H121.819V109.761H127.912Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 103.673V109.761H121.819V103.673H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 97.5802V103.673H121.819V97.5802H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 91.4919V97.5803H121.819V91.4919H127.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 85.3996V91.4919H121.819V85.3996H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 79.3113V85.3997H121.819V79.3113H127.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 73.2188V79.3112H121.819V73.2188H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 67.1303V73.2188H121.819V67.1303H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 61.038V67.1304H121.819V61.038H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 54.9418V61.0381H121.819V54.9418H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.912 48.8534V54.9418H121.819V48.8534H127.912Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 115.853V121.95H115.73V115.853H121.819Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 109.761V115.853H115.73V109.761H121.819Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 103.673V109.761H115.73V103.673H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 97.5802V103.673H115.73V97.5802H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 91.4919V97.5803H115.73V91.4919H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 85.3996V91.4919H115.73V85.3996H121.819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 79.3113V85.3997H115.73V79.3113H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 73.2188V79.3112H115.73V73.2188H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 67.1303V73.2188H115.73V67.1303H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 61.038V67.1304H115.73V61.038H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 54.9418V61.0381H115.73V54.9418H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.819 48.8534V54.9418H115.73V48.8534H121.819Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 115.853V121.95H109.639V115.853H115.731Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 109.761V115.853H109.639V109.761H115.731Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 103.673V109.761H109.639V103.673H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 97.5802V103.673H109.639V97.5802H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 91.4919V97.5803H109.639V91.4919H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 85.3996V91.4919H109.639V85.3996H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 79.3113V85.3997H109.639V79.3113H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 73.2188V79.3112H109.639V73.2188H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 67.1303V73.2188H109.639V67.1303H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.731 61.038V67.1304H109.639V61.038H115.731Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 115.853V121.95H103.547V115.853H109.639Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 109.761V115.853H103.547V109.761H109.639Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 97.5802V103.673H103.547V97.5802H109.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 91.4919V97.5803H103.547V91.4919H109.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 85.3996V91.4919H103.547V85.3996H109.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 79.3113V85.3997H103.547V79.3113H109.639Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 73.2188V79.3112H103.547V73.2188H109.639Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 67.1303V73.2188H103.547V67.1303H109.639Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 61.038V67.1304H103.547V61.038H109.639Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.639 0.130347V6.21875H103.547V0.130347H109.639Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 115.853V121.95H97.458V115.853H103.546Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 109.761V115.853H97.458V109.761H103.546Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 97.5802V103.673H97.458V97.5802H103.546Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 91.4919V97.5803H97.458V91.4919H103.546Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 85.3996V91.4919H97.458V85.3996H103.546Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 79.3113V85.3997H97.458V79.3113H103.546Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 73.2188V79.3112H97.458V73.2188H103.546Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.546 67.1303V73.2188H97.458V67.1303H103.546Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4585 115.853V121.95H91.3662V115.853H97.4585Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4585 109.761V115.853H91.3662V109.761H97.4585Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4585 85.3996V91.4919H91.3662V85.3996H97.4585Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4585 79.3113V85.3997H91.3662V79.3113H97.4585Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4585 73.2188V79.3112H91.3662V73.2188H97.4585Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4585 12.3111V18.3995H91.3662V12.3111H97.4585Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3657 115.853V121.95H85.2773V115.853H91.3657Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3657 109.761V115.853H85.2773V109.761H91.3657Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3657 79.3113V85.3997H85.2773V79.3113H91.3657Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3657 73.2188V79.3112H85.2773V73.2188H91.3657Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 115.853V121.95H79.1855V115.853H85.2779Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 109.761V115.853H79.1855V109.761H85.2779Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 73.2188V79.3112H79.1855V73.2188H85.2779Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 67.1303V73.2188H79.1855V67.1303H85.2779Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 61.038V67.1304H79.1855V61.038H85.2779Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 54.9418V61.0381H79.1855V54.9418H85.2779Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 48.8534V54.9418H79.1855V48.8534H85.2779Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2779 12.3111V18.3995H79.1855V12.3111H85.2779Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 115.853V121.95H73.0957V115.853H79.1841Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 109.761V115.853H73.0957V109.761H79.1841Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 67.1303V73.2188H73.0957V67.1303H79.1841Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 54.9418V61.0381H73.0957V54.9418H79.1841Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 48.8534V54.9418H73.0957V48.8534H79.1841Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 42.7611V48.8534H73.0957V42.7611H79.1841Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 18.3996V24.4919H73.0957V18.3996H79.1841Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1841 12.3111V18.3995H73.0957V12.3111H79.1841Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 115.853V121.95H67.001V115.853H73.0973Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 109.761V115.853H67.001V109.761H73.0973Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 54.9418V61.0381H67.001V54.9418H73.0973Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 48.8534V54.9418H67.001V48.8534H73.0973Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 42.7611V48.8534H67.001V42.7611H73.0973Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 36.6727V42.7611H67.001V36.6727H73.0973Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 24.4919V30.5803H67.001V24.4919H73.0973Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0973 18.3996V24.4919H67.001V18.3996H73.0973Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 115.853V121.95H60.9082V115.853H67.0005Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 109.761V115.853H60.9082V109.761H67.0005Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 97.5802V103.673H60.9082V97.5802H67.0005Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 91.4919V97.5803H60.9082V91.4919H67.0005Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 85.3996V91.4919H60.9082V85.3996H67.0005Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 79.3113V85.3997H60.9082V79.3113H67.0005Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 36.6727V42.7611H60.9082V36.6727H67.0005Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 30.5803V36.6726H60.9082V30.5803H67.0005Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0005 24.4919V30.5803H60.9082V24.4919H67.0005Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 115.853V121.95H54.8193V115.853H60.9077Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 109.761V115.853H54.8193V109.761H60.9077Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 103.673V109.761H54.8193V103.673H60.9077Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 97.5802V103.673H54.8193V97.5802H60.9077Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 91.4919V97.5803H54.8193V91.4919H60.9077Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 85.3996V91.4919H54.8193V85.3996H60.9077Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9077 79.3113V85.3997H54.8193V79.3113H60.9077Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 128.038V134.13H48.7266V128.038H54.8189Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 121.95V128.038H48.7266V121.95H54.8189Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 115.853V121.95H48.7266V115.853H54.8189Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 109.761V115.853H48.7266V109.761H54.8189Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 103.673V109.761H48.7266V103.673H54.8189Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 97.5802V103.673H48.7266V97.5802H54.8189Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 91.4919V97.5803H48.7266V91.4919H54.8189Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 85.3996V91.4919H48.7266V85.3996H54.8189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8189 79.3113V85.3997H48.7266V79.3113H54.8189Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 128.038V134.13H42.6387V128.038H48.7271Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 121.95V128.038H42.6387V121.95H48.7271Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 115.853V121.95H42.6387V115.853H48.7271Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 109.761V115.853H42.6387V109.761H48.7271Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 103.673V109.761H42.6387V103.673H48.7271Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 97.5802V103.673H42.6387V97.5802H48.7271Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 91.4919V97.5803H42.6387V91.4919H48.7271Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 85.3996V91.4919H42.6387V85.3996H48.7271Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 79.3113V85.3997H42.6387V79.3113H48.7271Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 67.1303V73.2188H42.6387V67.1303H48.7271Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 48.8534V54.9418H42.6387V48.8534H48.7271Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7271 42.7611V48.8534H42.6387V42.7611H48.7271Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 128.038V134.13H36.5469V128.038H42.6392Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 121.95V128.038H36.5469V121.95H42.6392Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 115.853V121.95H36.5469V115.853H42.6392Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 109.761V115.853H36.5469V109.761H42.6392Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 103.673V109.761H36.5469V103.673H42.6392Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 97.5802V103.673H36.5469V97.5802H42.6392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 91.4919V97.5803H36.5469V91.4919H42.6392Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 85.3996V91.4919H36.5469V85.3996H42.6392Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 79.3113V85.3997H36.5469V79.3113H42.6392Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 61.038V67.1304H36.5469V61.038H42.6392Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6392 54.9418V61.0381H36.5469V54.9418H42.6392Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 128.038V134.13H30.458V128.038H36.5464Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 121.95V128.038H30.458V121.95H36.5464Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 115.853V121.95H30.458V115.853H36.5464Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 109.761V115.853H30.458V109.761H36.5464Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 103.673V109.761H30.458V103.673H36.5464Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 97.5802V103.673H30.458V97.5802H36.5464Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 91.4919V97.5803H30.458V91.4919H36.5464Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 85.3996V91.4919H30.458V85.3996H36.5464Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 79.3113V85.3997H30.458V79.3113H36.5464Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5464 30.5803V36.6726H30.458V30.5803H36.5464Z",
    fill: "#F5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 128.038V134.13H24.3662V128.038H30.4586Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 121.95V128.038H24.3662V121.95H30.4586Z",
    fill: "#551826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 115.853V121.95H24.3662V115.853H30.4586Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 109.761V115.853H24.3662V109.761H30.4586Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 103.673V109.761H24.3662V103.673H30.4586Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 97.5802V103.673H24.3662V97.5802H30.4586Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 91.4919V97.5803H24.3662V91.4919H30.4586Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 85.3996V91.4919H24.3662V85.3996H30.4586Z",
    fill: "#FFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4586 79.3113V85.3997H24.3662V79.3113H30.4586Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 115.853V121.95H18.2773V115.853H24.3657Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 109.761V115.853H18.2773V109.761H24.3657Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 97.5802V103.673H18.2773V97.5802H24.3657Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 91.4919V97.5803H18.2773V91.4919H24.3657Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 85.3996V91.4919H18.2773V85.3996H24.3657Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 79.3113V85.3997H18.2773V79.3113H24.3657Z",
    fill: "#00eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2769 115.853V121.95H12.1846V115.853H18.2769Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2769 109.761V115.853H12.1846V109.761H18.2769Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1851 115.853V121.95H6.08887V115.853H12.1851Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1851 109.761V115.853H6.08887V109.761H12.1851Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0884 115.853V121.95H0V115.853H6.0884Z",
    fill: "#6B2C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0884 109.761V115.853H0V109.761H6.0884Z",
    fill: "#6B2C3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.3c0ee9a24ebd0f05da972241a6fcc9ec.svg";
export { ForwardRef as ReactComponent };